<template>
  <v-container>
    <v-row class="flex-column justify-start pa-2" dense>
      <v-col class="text-h6">
        <div>Calculer un prix</div>
      </v-col>

      Pour calculer le prix de détail ou le prix fournisseur, remplissez les
      champs ci-dessous.
      <v-divider class="pb-6" />

      <v-layout>
        <v-flex md3 pt-1 pb-3 style="font-size: 13px">
          * Pays d'enlèvement
        </v-flex>

        <v-flex
          v-if="
            paysEnlevementSelectionne.paysRegion != null &&
              paysEnlevementSelectionne.paysRegion.code == null
          "
          md3
        >
          <v-autocomplete
            v-model.trim="paysEnlevementSelectionne"
            :items="listePaysFrequents"
            item-value="paysRegion.code"
            :item-text="item => item.paysRegion.fr"
            class="text-caption pa-0 ma-0"
            style="color: black;"
            label="Sélectionnez"
            dense
            single-line
            hide-no-data
            @change="obtenirListeRegionSelonPays()"
          />
        </v-flex>

        <v-flex v-else md3>
          <v-autocomplete
            v-model.trim="paysEnlevementSelectionne"
            :items="listePays"
            item-value="paysRegion.code"
            label="Sélectionnez"
            :item-text="item => item.paysRegion.fr"
            class="text-caption pa-0 ma-0"
            style="color: black;"
            dense
            single-line
            hide-no-data
            @change="obtenirListeRegionSelonPays()"
          />
        </v-flex>

        <v-flex md1>
          <v-btn
            text
            x-small
            color="primary"
            @click.stop="dialogEnlevement = true"
          >
            Tous
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout v-if="listeRegion.length > 0">
        <v-flex md3 pt-1> Région </v-flex>

        <v-flex md3>
          <v-select
            v-model="regionSelectionne"
            :items="listeRegion"
            label="Sélectionnez"
            item-value="1"
            item-text="0"
            class="text-caption pa-0"
            style="color: black;"
            dense
            height="40"
            single-line
            hide-no-data
            @change="obtenirListeSousRegionSelonRegion()"
          >
            <template v-slot:selection="data">
              {{ data.item.paysRegion.fr }}
            </template>
            <template v-slot:item="data">
              {{ data.item.paysRegion.fr }}
            </template>
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-1 style="font-size: 13px">
          Code Postal d'enlèvement
        </v-flex>
        <v-flex md2>
          <v-text-field
            v-model.trim="demande.demandeLigneData.codePostalPaysEnlevement"
            class="pa-0"
            style="color: black;"
            single-line
            dense
            outlined
          />
        </v-flex>
      </v-layout>

      <v-radio-group v-model="radioGroup" class="ml-4 mb-12">
        <v-radio value="FCA">
          <template v-slot:label>
            <div class="font-weight-bold" style="font-size: 13px">
              Terme d'achat FCA - transport assuré par la SAQ à partir du lieu
              d'enlèvement désigné par la SAQ
            </div>
          </template>
        </v-radio>

        <v-radio value="DDU">
          <template v-slot:label>
            <div class="font-weight-bold" style="font-size: 13px">
              Terme d'achat DDU - transport assuré par avion par le fournisseur
            </div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-layout>
        <v-flex md3 pt-1 style="font-size: 13px"> * Nom du produit </v-flex>
        <v-flex md5>
          <v-text-field
            v-model.trim="demande.demandeLigneData.description"
            class="pa-0"
            style="color: black;"
            single-line
            dense
            outlined
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-1 style="font-size: 13px">
          Millésime / âge
        </v-flex>
        <v-flex md2>
          <v-text-field
            v-model.trim="demande.demandeLigneData.millesime"
            class="pa-0"
            style="color: black;"
            single-line
            dense
            outlined
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-1 style="font-size: 13px"> * % d'alcool </v-flex>
        <v-flex md2>
          <v-text-field
            v-model.trim="demande.demandeLigneData.pourcentageAlcool"
            class="pa-0"
            style="color: black;"
            single-line
            dense
            outlined
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-1 pb-3 style="font-size: 13px">
          * Pays d'origine
        </v-flex>

        <v-flex
          v-if="
            paysSelectionne.paysRegion != null &&
              paysSelectionne.paysRegion.code == null
          "
          md3
        >
          <v-autocomplete
            v-model.trim="paysSelectionne"
            :items="listePaysFrequents"
            item-value="paysRegion.code"
            :item-text="item => item.paysRegion.fr"
            class="text-caption pa-0 ma-0"
            style="color: black;"
            label="Sélectionnez"
            dense
            single-line
            hide-no-data
          />
        </v-flex>

        <v-flex v-else md3>
          <v-autocomplete
            v-model.trim="paysSelectionne"
            :items="listePays"
            item-value="paysRegion.code"
            label="Sélectionnez"
            :item-text="item => item.paysRegion.fr"
            class="text-caption pa-0 ma-0"
            style="color: black;"
            dense
            single-line
            hide-no-data
          />
        </v-flex>

        <v-flex md1>
          <v-btn text x-small color="primary" @click.stop="dialog = true">
            Tous
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-1 style="font-size: 13px"> * Nature </v-flex>

        <v-flex md3>
          <v-select
            v-model="natureSelectionne"
            :items="listeNature"
            label="Sélectionnez"
            item-text="0"
            item-value="1"
            class="text-caption pa-0"
            style="color: black;"
            dense
            height="40"
            single-line
            hide-no-data
            @change="obtenirListeFamilleSelonNature()"
          >
            <template v-slot:selection="data">
              {{ data.item.natureFamilleType.fr }}
            </template>
            <template v-slot:item="data">
              {{ data.item.natureFamilleType.fr }}
            </template>
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-1 style="font-size: 13px"> * Couleur </v-flex>

        <v-flex md3>
          <v-select
            v-model="couleur"
            :items="listeCouleurSelonNature"
            label="Sélectionnez"
            item-text="0"
            item-value="1"
            class="text-caption pa-0"
            style="color: black;"
            dense
            height="40"
            single-line
            hide-no-data
          >
            <template v-slot:selection="data">
              {{ data.item.couleur.fr }}
            </template>
            <template v-slot:item="data">
              {{ data.item.couleur.fr }}
            </template>
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-1 style="font-size: 13px"> * Famille </v-flex>

        <v-flex md3>
          <v-select
            v-model="familleSelectionne"
            :items="listeFamille"
            label="Sélectionnez"
            item-text="0"
            item-value="1"
            class="text-caption pa-0"
            style="color: black;"
            dense
            height="40"
            single-line
            hide-no-data
            @change="obtenirTypeSelonFamille()"
          >
            <template v-slot:selection="data">
              {{ data.item.natureFamilleType.fr }}
            </template>
            <template v-slot:item="data">
              {{ data.item.natureFamilleType.fr }}
            </template>
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-1 style="font-size: 13px"> * Format </v-flex>
        <v-flex md2 pt-1>
          <v-text-field
            v-model.trim="demande.demandeLigneData.format"
            class="pa-0"
            style="color: black;"
            single-line
            dense
            outlined
          />
        </v-flex>

        <v-flex md1 ml-5>
          <v-select
            v-model="demande.demandeLigneData.uniteMesure"
            :items="formatsBouteille"
            item-text="1"
            item-value="0"
            class="text-caption pa-0"
            dense
            height="40"
            single-line
            hide-no-data
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-3 style="font-size: 13px">
          Type de contenant
        </v-flex>
        <v-flex md3>
          <v-select
            v-model="demande.demandeLigneData.typeContenant"
            required
            :items="typeContenants"
            label="Sélectionnez"
            item-text="1"
            item-value="0"
            class="text-caption pa-0"
            style="color: black;"
            dense
            height="40"
            single-line
            hide-no-data
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-3 style="font-size: 13px">
          * Nbre bouteilles / caisse (UVC)
        </v-flex>
        <v-flex md2 pt-1>
          <v-text-field
            v-model.trim="demande.demandeLigneData.uvc"
            class="pa-0"
            style="color: black;"
            single-line
            dense
            outlined
          />
        </v-flex>
      </v-layout>

      <div class="pb-10" style="font-size: 13px">
        Il est à noter que le prix calculé est approximatif et qu'il vous sera
        confirmé après l'acceptation du fournisseur
      </div>

      <v-layout>
        <v-flex md3 pt-3 style="font-size: 13px">
          Devise du fournisseur
        </v-flex>
        <v-flex md3>
          <v-select
            v-model="demande.demandeLigneData.devise"
            :items="devises"
            item-text="1"
            item-value="0"
            label="Sélectionnez"
            class="text-caption pa-0"
            dense
            height="40"
            single-line
            hide-no-data
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-5 style="font-size: 13px">
          * Prix
        </v-flex>

        <v-flex md3 pt-5 style="font-size: 13px">
          <v-select
            v-model="demande.demandeLigneData.typePrix"
            :items="typesPrix"
            item-text="1"
            item-value="0"
            label="Sélectionnez"
            class="text-caption pa-0"
            dense
            height="40"
            single-line
            hide-no-data
            @change="remettreBlancPrix()"
          />
        </v-flex>

        <v-flex md2 pt-1 pl-5>
          <v-text-field
            v-model.trim="prix"
            class="pa-0"
            single-line
            dense
            outlined
          />
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex md3 pt-8>
          <v-btn
            medium
            color="primary"
            style="text-transform: none;"
            class="white--text"
            :disabled="sending"
            @click="soumettreAppelCalculette()"
          >
            Calculer le prix de vente estimé
          </v-btn>
        </v-flex>
      </v-layout>

      <v-flex
        v-if="
          resultatCalculette.prixDetailRevise != null &&
            demande.demandeLigneData.typePrix == 'PRIX_FOURNISSEUR'
        "
        md8
        ml-5
        mt-5
        mb-5
      >
        <div class="font-weight-bold">
          Prix de vente estimé :
          {{ $fmtDecimal(resultatCalculette.prixDetailRevise) }} $
        </div>

        <div>
          Calculé le {{ $fmtTsEnDateEcrite() }} selon les derniers taux publiés.
        </div>
      </v-flex>

      <v-flex
        v-if="
          resultatCalculette.prixDetailRevise != null &&
            demande.demandeLigneData.typePrix == 'PRIX_DETAIL'
        "
        md8
        ml-5
        mt-5
        mb-5
      >
        <div class="font-weight-bold">
          Prix fournisseur :
          {{ $fmtDecimal(resultatCalculette.prixFOB) }} $
          {{ devisevaleur.get(demande.demandeLigneData.devise) }}
        </div>

        <div class="font-weight-bold">
          Prix de vente arrondi :
          {{ $fmtDecimal(resultatCalculette.prixDetailRevise) }} $ CAD
        </div>

        <div class="pt-3">
          Calculé le {{ $fmtTsEnDateEcrite() }} selon les derniers taux publiés.
        </div>
        <div class="pt-3">
          Les prix de détail sont en dollars canadiens et respectent la
          politique d'arrondissement des prix de la SAQ.
        </div>
      </v-flex>

      <!-- ------------------ -->
      <!--- Dialog des pays ---->
      <!-- ------------------ -->
      <v-dialog v-model="dialog" width="450">
        <v-card>
          <v-layout>
            <v-flex md10 style="font-size: 12px">
              <v-card-title class="text-h6">Liste des pays</v-card-title>
            </v-flex>
            <v-flex md4 pt-3 pl-5 style="font-size: 12px">
              <v-btn text color="primary" dark @click="close">Fermer</v-btn>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-row>
              <v-flex
                v-for="(item, index) in listePaysEtLettreFr"
                :key="item.id"
                pl-8
                md1
                :item="item"
                :index="index"
              >
                <a :href="`#${item.lettre}`">
                  {{ item.lettre }}
                </a>
              </v-flex>
            </v-row>
          </v-layout>
          <v-layout>
            <div id="listePaysEtLettre">
              <v-flex
                v-for="(item, index) in listePaysEtLettreFr"
                :key="item.id"
                pl-5
                :item="item"
                :index="index"
              >
                <div :id="item.lettre"><br /></div>
                <hr />
                <v-flex
                  v-for="(item2, index2) in item.paysRegions"
                  :key="item2.code"
                  :item="item2"
                  :index="index2"
                >
                  <a @click="initPays(item2)">
                    {{ item2.fr }}
                  </a>
                </v-flex>
              </v-flex>
            </div>
          </v-layout>
          <v-btn text color="primary" dark @click="close">Fermer</v-btn>
        </v-card>
      </v-dialog>

      <!-- ---------------------------- -->
      <!--- Dialog des pays Enlevement---->
      <!-- ---------------------------- -->
      <v-dialog v-model="dialogEnlevement" width="450">
        <v-card>
          <v-layout>
            <v-flex md10 style="font-size: 12px">
              <v-card-title class="text-h6">Liste des pays</v-card-title>
            </v-flex>
            <v-flex md4 pt-3 pl-5 style="font-size: 12px">
              <v-btn text color="primary" dark @click="closeEnlevement"
                >Fermer</v-btn
              >
            </v-flex>
          </v-layout>

          <v-layout>
            <v-row>
              <v-flex
                v-for="(item, index) in listePaysEtLettreFr"
                :key="item.id"
                pl-8
                md1
                :item="item"
                :index="index"
              >
                <a :href="`#${item.lettre}`">
                  {{ item.lettre }}
                </a>
              </v-flex>
            </v-row>
          </v-layout>
          <v-layout>
            <div id="listePaysEtLettre">
              <v-flex
                v-for="(item, index) in listePaysEtLettreFr"
                :key="item.id"
                pl-5
                :item="item"
                :index="index"
              >
                <div :id="item.lettre"><br /></div>
                <hr />
                <v-flex
                  v-for="(item2, index2) in item.paysRegions"
                  :key="item2.code"
                  :item="item2"
                  :index="index2"
                >
                  <a @click="initPaysEnlevement(item2)">
                    {{ item2.fr }}
                  </a>
                </v-flex>
              </v-flex>
            </div>
          </v-layout>
          <v-btn text color="primary" dark @click="closeEnlevement"
            >Fermer</v-btn
          >
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import {
  formatsBouteille,
  typeContenant,
  devises,
  typesPrix
} from '@/plugins/enums'
export default {
  name: 'CalculerPrix',
  data() {
    return {
      demande: { clientData: {}, demandeLigneData: {} },
      dialog: false,
      dialogEnlevement: false,
      sending: false,
      prix: null,
      resultatCalculette: {},
      paysSelectionne: { paysRegion: {} },
      paysEnlevementSelectionne: { paysRegion: {} },
      regionSelectionne: { paysRegion: {} },
      sousRegionSelectionne: { paysRegion: {} },
      natureSelectionne: { natureFamilleType: {} },
      familleSelectionne: { natureFamilleType: {} },
      couleur: { couleur: {} },
      listePaysFrequents: [],
      listePays: [],
      listePaysEtLettreFr: [],
      listeNature: [],
      listeRegion: [],
      listeCouleur: [],
      listeCouleurSelonNature: [],
      listeSousRegion: [],
      listeFamille: [],
      radioGroup: 'FCA'
    }
  },

  computed: {
    formatsBouteille: function() {
      return Array.from(formatsBouteille)
    },
    formatBouteille: function() {
      return formatsBouteille
    },
    typeContenants: function() {
      return Array.from(typeContenant)
    },
    listeTypeContenants: function() {
      return typeContenant
    },
    devises: function() {
      return Array.from(devises)
    },
    devisevaleur: function() {
      return devises
    },
    typesPrix: function() {
      return Array.from(typesPrix)
    }
  },

  beforeMount() {
    this.obtenirListeCouleur()

    this.obtenirListePays()
    this.obtenirListePaysFrequent()
    this.obtenirListePaysLettreFr()
    this.obtenirListeNature()
  },

  methods: {
    initPays(item) {
      if (item != null) {
        console.log(
          'initPays ' +
            this.paysSelectionne +
            'item ' +
            item.fr +
            ' ' +
            item.code
        )

        this.paysSelectionne = { paysRegion: {} }

        if (this.paysSelectionne.paysRegion != null) {
          this.paysSelectionne.paysRegion.actif = true
          this.paysSelectionne.paysRegion.code = item.code.toString(2)
          this.paysSelectionne.paysRegion.fr = item.fr
          this.paysSelectionne.paysRegion.en = item.en
        }
      }

      this.close()
    },

    initPaysEnlevement(item) {
      if (item != null) {
        console.log(
          'initPays ' +
            this.paysEnlevementSelectionne +
            'item ' +
            item.fr +
            ' ' +
            item.code
        )

        this.paysEnlevementSelectionne = { paysRegion: {} }

        if (this.paysEnlevementSelectionne.paysRegion != null) {
          this.paysEnlevementSelectionne.paysRegion.actif = true
          this.paysEnlevementSelectionne.paysRegion.code = item.code.toString(2)
          this.paysEnlevementSelectionne.paysRegion.fr = item.fr
          this.paysEnlevementSelectionne.paysRegion.en = item.en
        }
      }

      this.closeEnlevement()
    },

    obtenirListePaysFrequent() {
      axios
        .get(`/paysregion/paysfrequent`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listePaysFrequents = resp.resultat

              this.listePaysFrequents.sort(function(a, b) {
                return a.paysRegion.fr.localeCompare(b.paysRegion.fr)
              })

              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirTypeSelonFamille() {
      this.listeType = []

      console.log(
        'obtenirTypeSelonFamille' +
          this.familleSelectionne.natureFamilleType.code
      )

      axios
        .get(
          `/naturefamille/obtenirtype/${this.familleSelectionne.natureFamilleType.code}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeType = resp.resultat
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListePaysLettreFr() {
      axios
        .get(`/paysregion/listepayslettrefr`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listePaysEtLettreFr = resp.resultat
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeFamilleSelonNature() {
      this.listeFamille = []

      console.log(
        'obtenirListeFamilleSelonNature ' +
          this.natureSelectionne.natureFamilleType.code
      )

      axios
        .get(
          `/naturefamille/obtenirfamille/${this.natureSelectionne.natureFamilleType.code}`
        )
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeFamille = resp.resultat
              this.initCouleur()
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListePays() {
      axios
        .get(`/paysregion/listepays`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listePays = resp.resultat

              this.listePays.sort(function(a, b) {
                return a.paysRegion.fr.localeCompare(b.paysRegion.fr)
              })
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeRegionSelonPays() {
      console.log(
        'obtenirListeRegionSelonPays ' + this.paysEnlevementSelectionne
      )
      this.listeRegion = []

      axios
        .get(`/paysregion/obtenirregion/${this.paysEnlevementSelectionne}`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeRegion = resp.resultat
              break
            case 'W001':
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeNature() {
      axios
        .get(`/naturefamille/listenature`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeNature = resp.resultat

              this.listeNature.sort(function(a, b) {
                return a.natureFamilleType.fr.localeCompare(
                  b.natureFamilleType.fr
                )
              })
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    obtenirListeCouleur() {
      axios
        .get(`/naturefamille/listecouleur`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.listeCouleur = resp.resultat
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    initCouleur() {
      console.log('initCouleur ' + this.natureSelectionne.natureFamilleType.fr)

      this.listeCouleurSelonNature = []

      if (this.natureSelectionne.natureFamilleType.fr == 'Poiré') {
        for (let i = 0; i < this.listeCouleur.length; i++) {
          if (
            this.listeCouleur[i].couleur.code == '01' ||
            this.listeCouleur[i].couleur.code == '04' ||
            this.listeCouleur[i].couleur.code == '61' ||
            this.listeCouleur[i].couleur.code == '03' ||
            this.listeCouleur[i].couleur.code == '02' ||
            this.listeCouleur[i].couleur.code == '33' ||
            this.listeCouleur[i].couleur.code == '00'
          ) {
            this.listeCouleurSelonNature.push(this.listeCouleur[i])
          }
        }
      } else if (this.natureSelectionne.natureFamilleType.fr == 'Saké') {
        for (let i = 0; i < this.listeCouleur.length; i++) {
          if (
            this.listeCouleur[i].couleur.code == '13' ||
            this.listeCouleur[i].couleur.code == '01' ||
            this.listeCouleur[i].couleur.code == '61' ||
            this.listeCouleur[i].couleur.code == '44' ||
            this.listeCouleur[i].couleur.code == '00'
          ) {
            this.listeCouleurSelonNature.push(this.listeCouleur[i])
          }
        }
      } else {
        for (let i = 0; i < this.listeCouleur.length; i++) {
          if (
            this.listeCouleur[i].couleur.code == '01' ||
            this.listeCouleur[i].couleur.code == '03' ||
            this.listeCouleur[i].couleur.code == '02' ||
            this.listeCouleur[i].couleur.code == '00'
          ) {
            this.listeCouleurSelonNature.push(this.listeCouleur[i])
          }
        }
      }
    },

    close() {
      this.dialog = false
    },

    closeEnlevement() {
      this.dialogEnlevement = false
    },

    obtenirTermeAchat() {
      console.log('obtenirTermeAchat ')

      axios
        .post(`/calculette/obtenirtermeachat`, this.demande)
        .then(response => {
          let resp = response.data
          let msg = null

          switch (resp.codeRetour) {
            case 'OK':
              this.demande = resp.resultat
              break

            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    soumettreAppelCalculette() {
      console.log('soumettreAppelCalculette')

      this.soumisCalculette = true

      this.demande.demandeLigneData.uniteMesure = 'MILLILITRE'

      if (this.demande.demandeLigneData.description == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le nom du produit est obligatoire'
        )
        return
      }

      if (this.natureSelectionne.natureFamilleType.code == null) {
        this.$store.dispatch('afficherWarning', 'La nature est obligatoire')
        return
      }

      if (this.familleSelectionne.natureFamilleType.code == null) {
        this.$store.dispatch('afficherWarning', 'La famille est obligatoire')
        return
      }

      if (this.paysSelectionne == null) {
        this.$store.dispatch(
          'afficherWarning',
          "Le pays d'origine est obligatoire"
        )
        return
      }

      if (this.paysEnlevementSelectionne == null) {
        this.$store.dispatch(
          'afficherWarning',
          "Le pays d'enlèvement est obligatoire"
        )
        return
      }

      if (this.couleur == null) {
        this.$store.dispatch('afficherWarning', 'La couleur est obligatoire')
        return
      }

      if (this.demande.demandeLigneData.pourcentageAlcool == null) {
        this.$store.dispatch(
          'afficherWarning',
          "Le pourcentage d'alcool est obligatoire"
        )
        return
      }

      if (this.demande.demandeLigneData.format == null) {
        this.$store.dispatch('afficherWarning', 'Le format est obligatoire')
        return
      } else {
        this.demande.demandeLigneData.format = this.demande.demandeLigneData.format
          .toString()
          .replace(/\s/g, '')

        if (this.demande.demandeLigneData.format > 20000) {
          this.$store.dispatch(
            'afficherWarning',
            'Le maximum comme format est de 20 000 ml'
          )
          return
        }
      }

      if (this.demande.demandeLigneData.uvc == null) {
        this.$store.dispatch(
          'afficherWarning',
          'Le nombre de bouteilles / caisse'
        )
        return
      }

      if (this.prix == null) {
        this.$store.dispatch('afficherWarning', 'Le prix est obligatoire')
        return
      }

      if (this.demande.demandeLigneData.pourcentageAlcool != null) {
        this.demande.demandeLigneData.pourcentageAlcool = this.demande.demandeLigneData.pourcentageAlcool
          .toString()
          .replace(',', '.')
      }

      if (this.demande.demandeLigneData.format != null) {
        this.demande.demandeLigneData.format = this.demande.demandeLigneData.format
          .toString()
          .replace(',', '.')
      }

      if (this.prix != null) {
        this.prix = this.prix.toString().replace(',', '.')
      }

      this.resultatCalculette = {}

      this.demande.demandeLigneData.codePays = this.paysSelectionne
      this.demande.demandeLigneData.codePaysEnlevement = this.paysEnlevementSelectionne

      this.demande.demandeLigneData.prix = this.prix
      this.demande.termeAchat = this.radioGroup
      this.demande.demandeLigneData.codeNature = this.natureSelectionne.natureFamilleType.code
      this.demande.demandeLigneData.codeFamille = this.familleSelectionne.natureFamilleType.code
      this.demande.demandeLigneData.codeCouleur = this.couleur.couleur.code
      this.demande.demandeLigneData.indSimulation = true

      this.appelCalculette()
    },

    appelCalculette() {
      console.log(
        'appelCalculette ',
        this.$store.getters.currentUser.agentData.noClientJDE
      )
      this.sending = true

      this.demande.clientData.noClientJDE = this.$store.getters.currentUser.agentData.noClientJDE

      axios
        .post(`/calculette/simulation`, this.demande)
        .then(response => {
          let resp = response.data
          let msg = null

          switch (resp.codeRetour) {
            case 'OK':
              this.demande = resp.resultat
              this.resultatCalculette = this.demande.resultatCalculette

              if (this.resultatCalculette.prixDetailRevise == 0) {
                this.$store.dispatch(
                  'afficherError',
                  "Il n'est pas possible de calculer le prix pour le moment."
                )
              }

              break
            case 'X001':
            case 'V200':
              this.$store.dispatch(
                'afficherError',
                "Il n'est pas possible de calculer le prix pour le moment."
              )
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },

    remettreBlancPrix() {
      this.resultatCalculette = {}
    }
  }
}
</script>

<style scoped>
div {
  font-size: 15px;
}
</style>
